import Color from 'color';
export default (color, opacity) => Color(color).alpha(opacity).string();
